import React from "react";
import PropTypes from "prop-types";

// context
import { usePanelOverlay } from "../usePanelOverlay";

// components
import { UnstyledButton } from "core/Button/styles.js";

// component
export const OpenButton = ({ children }) => {
    const { open, label, id } = usePanelOverlay();

    return (
        <UnstyledButton
            onClick={open}
            id={`open-modal-${id}`}
            aria-label={`Open ${label}`}
        >
            {children}
        </UnstyledButton>
    );
};

export default OpenButton;

// prop-types
OpenButton.propTypes = {
    children: PropTypes.any
};
